import { useTranslation } from 'react-i18next';
import { ChevronLeftIcon, ChevronRightIcon } from '@utils/icons';
import { Tooltip } from '@components/ui/Tooltip/Tooltip';
import strip from '../ControlsRow.module.css';
import styles from './PageControls.module.css';

interface IPageControlsProps {
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
}

/** The pager: stepped ‹ / › buttons around the current page, for a multi-page PDF. */
export function PageControls({ page, pageCount, onPageChange }: IPageControlsProps) {
  const { t } = useTranslation();

  return (
    <div className={strip.group}>
      <Tooltip content={t('documents.markup.prevPage')}>
        <button
          type="button"
          className={strip.btn}
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          aria-label={t('documents.markup.prevPage')}
        >
          <ChevronLeftIcon size={15} />
        </button>
      </Tooltip>

      <span className={styles.label}>{t('documents.markup.pageOf', { page, total: pageCount })}</span>

      <Tooltip content={t('documents.markup.nextPage')}>
        <button
          type="button"
          className={strip.btn}
          onClick={() => onPageChange(Math.min(pageCount, page + 1))}
          disabled={page >= pageCount}
          aria-label={t('documents.markup.nextPage')}
        >
          <ChevronRightIcon size={15} />
        </button>
      </Tooltip>
    </div>
  );
}
